import { CSSProperties } from 'react';
import colors from '../../../../assets/theme/base/colors';

const groupHeader: CSSProperties = {
    textAlign: 'center',
    padding: '8px 12px',
    fontSize: '0.8125rem',
    fontWeight: 700,
    color: colors.white.main,
    textTransform: 'uppercase',
    borderRight: `1px solid ${colors.ui.tableHeaderBandBorder}`,
    borderBottom: `1px solid ${colors.ui.tableHeaderBandBorder}`,
    whiteSpace: 'nowrap',
};

const groupHeaderLast: CSSProperties = {
    ...groupHeader,
    borderRight: 'none',
};

const subHeader: CSSProperties = {
    textAlign: 'center',
    padding: '6px 8px',
    fontSize: '0.6875rem',
    fontWeight: 600,
    color: colors.white.main,
    textTransform: 'uppercase',
    lineHeight: 1.25,
    verticalAlign: 'middle',
};

const subHeaderGroupBoundary: CSSProperties = {
    ...subHeader,
    borderRight: `1px solid ${colors.ui.tableHeaderBandBorder}`,
};

const subHeaderLast: CSSProperties = {
    ...subHeader,
    borderRight: 'none',
};

const groupCellRowSpan: CSSProperties = {
    textAlign: 'left',
    padding: '8px 16px',
    fontSize: '0.8125rem',
    fontWeight: 700,
    color: colors.white.main,
    textTransform: 'uppercase',
    borderRight: `1px solid ${colors.ui.tableHeaderBandBorder}`,
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
};

export function PlanSummaryTableHeader() {
    return (
        <thead style={{ backgroundColor: colors.ui.tableHeaderBand }}>
            <tr>
                <th rowSpan={2} style={groupCellRowSpan}>Group</th>
                <th colSpan={2} style={groupHeader}>Start</th>
                <th colSpan={4} style={groupHeader}>Movements</th>
                <th colSpan={2} style={groupHeader}>Current</th>
                <th colSpan={2} style={groupHeader}>Target</th>
                <th colSpan={2} style={groupHeader}>Variance</th>
                <th colSpan={2} style={groupHeaderLast}>Priority</th>
            </tr>
            <tr>
                <th style={subHeader}>#</th>
                <th style={subHeaderGroupBoundary}>%</th>
                <th style={subHeader}>Recruited</th>
                <th style={subHeader}>Promoted In</th>
                <th style={subHeader}>Promoted Out</th>
                <th style={subHeaderGroupBoundary}>Terminated</th>
                <th style={subHeader}>#</th>
                <th style={subHeaderGroupBoundary}>%</th>
                <th style={subHeader}>#</th>
                <th style={subHeaderGroupBoundary}>%</th>
                <th style={subHeader}>#</th>
                <th style={subHeaderGroupBoundary}>%</th>
                <th style={subHeader}>Relative % Gap</th>
                <th style={subHeaderLast}>Rank</th>
            </tr>
        </thead>
    );
}
